const React = require('react');
const Dialog = require('components/dialog');

var service = {

	config: {
		title: 'Título da caixa de diálogo',
		message: 'Mensagem a ser exibida no corpo da caixa de diálogo',
		btnClass: 'primary'
	},

	show(callback,title,message,btnClass){
		service.config.callback = callback;
		if (title) service.config.title = title;
		if (message) service.config.message = message;
		if (btnClass) service.config.btnClass = btnClass;
		service.refreshDialog();
		service.componentRef.show();
	},

	mixin: {

		componentDidMount(){
			service.refreshDialog = this.refreshDialog;
			if (this.refs.dialog) service.componentRef = this.refs.dialog;
		},

		componentDidUpdate(){
			if (this.refs.dialog) service.componentRef = this.refs.dialog;
		},

		refreshDialog(){
			this.setState({});
		},

		renderModals(){

			var callback;

			if (service.config.callback) {
				callback = function(){
					service.componentRef.hide();
					service.config.callback();
				}
			}

			return (
				<Dialog ref='dialog' 
						title={service.config.title} 
						onConfirm={callback} 
						btnClass={service.config.btnClass} >
					{service.config.message}
				</Dialog>
			);
		}
	}


};

module.exports = service;


/** WEBPACK FOOTER **
 ** ./src/utils/modal-service.js
 **/